export default function() {

    const menuBtn = $('.header .header-menu');
    const closeBtn = $('.nav-menu-panel__close');
    const menuPanel = $('#nav-menu-panel');
    const allNavLinks = getNavLinks();
    const newNavHTML = buildNavMenu(allNavLinks);


    // scrape nav links from default #mainNavigation
    function getNavLinks() {
        const mainNav = $('#mainNavigation');
        const allLinks = [];

        mainNav.find('.group').each(function() {
            const topLink = $(this);
            const items = topLink.find('.items');
            const topLinkURL = topLink.find('a').first().attr('href');
            const topLinkText = topLink.find('a').first().text();
            let itemsLinks = [];
            
            if (items) {
                items.find('> .item').each(function() {
                    const subLink = $(this);
                    const subitems = subLink.find('> .subitems');
                    const subLinkURL = subLink.find('a').first().attr('href');
                    const subLinkText = subLink.find('a').first().text();
                    let subItemsLinks = [];

                    if (subitems) {
                        subitems.find('> .item').each(function() {
                            const subsubLink = $(this);
                            const subsubLinkURL = subsubLink.find('a').first().attr('href');
                            const subsubLinkText = subsubLink.find('a').first().text();

                            subItemsLinks.push({
                                subSubLevelLink: subsubLinkText,
                                subSubLevelURL: subsubLinkURL,
                            });
                        });
                    } else {
                        subItemsLinks = null;
                    }


                    itemsLinks.push({
                        subLevelLink: subLinkText,
                        subLevelURL: subLinkURL,
                        subitems: subItemsLinks
                    });
                });
            } else {
                itemsLinks = null;
            }

            allLinks.push({
                topLevelLink: topLinkText,
                topLevelURL: topLinkURL,
                items: itemsLinks
            });
        });

        // console.log(allLinks)
        return allLinks;
    }




    function buildNavMenu(links) {
        let newNavMenu = '';
        links.forEach((item, i) => {
            const subItems = item.items;
            const hasSubitems = subItems.length > 0 ? true : false;

            let subItemHTML = '';
            
            if (subItems.length > 0) {
                subItems.forEach((subItem, i) => {             
                    const subsubItems = subItem.subitems;
                    const hasSubSubitems = subsubItems.length > 0 ? true : false;       

                    let subSubItemHTML = '';
                    
                    if (subsubItems.length > 0) {                        

                        subsubItems.forEach((subsubItem, i) => { 

                            subSubItemHTML += `
                                <li class="nav-items-3__item">
                                    <a href="${subsubItem.subSubLevelURL}">${subsubItem.subSubLevelLink}</a>
                                </li>
                            `;
                        });
                    }

                    let subLevelLinkEl = ``;
                    if (!hasSubSubitems) {
                        subLevelLinkEl = `<a href="${subItem.subLevelURL}">${subItem.subLevelLink}</a>`;
                    } else {
                        subLevelLinkEl = `<a href="javascript:void(0);">${subItem.subLevelLink}</a>`;
                    }


                    subItemHTML += `
                        <li class="nav-items-2__item" data-has-subsubitems="${hasSubSubitems}">
                            <div>
                                ${subLevelLinkEl}
                                <span></span>
                            </div>
                            <ul class="nav-items-3">${subSubItemHTML}</ul>
                        </li>
                    `;
                });
            }

            let topLevelLinkEl = ``;
            if (!hasSubitems) {
                topLevelLinkEl = `<a href="${item.topLevelURL}">${item.topLevelLink}</a>`;
            } else {
                topLevelLinkEl = `<a href="${item.topLevelURL}">${item.topLevelLink}</a>`;
            }
            
            let linkHTML = `
                <li class="nav-items-1__item" data-has-subitems="${hasSubitems}">
                    <div>
                        ${topLevelLinkEl}
                        <span></span>
                    </div>  
                    <ul class="nav-items-2">${subItemHTML}</ul>
                </li>
            `;

            newNavMenu += linkHTML;
        });

        return newNavMenu;
    }


    $('.nav-menu-panel__inner').prepend(`<nav class="nav-menu-panel__nav"><ul class="nav-items-1">${newNavHTML}</ul></nav>`);
	
	$(".nav-menu-panel .nav-menu-panel__nav ul.nav-items-1 li.nav-items-1__item:first-child .nav-items-2 li.nav-items-2__item:first-child a").text('Event Calendar');

	$('.saffireLargeSize .nav-items-1__item').hover(function() {
	  $(this).toggleClass('expanded');
	});
	
	
    // menu accordion 
    const navMenu = $('.nav-menu-panel__nav');
    const navL1 = navMenu.find('.nav-items-1__item[data-has-subitems="true"] > div');
    const navL2 = navMenu.find('.nav-items-2__item[data-has-subsubitems="true"] > div');

    navL1.on('click keydown', (event) => {
        // console.log(event)
        const $thisEl = $(event.currentTarget);
        const $parentItem = $thisEl.parent();
        navL1.parent().not($parentItem).removeClass('expanded');
        navL2.parent().removeClass('expanded');
        $parentItem.toggleClass('expanded');
    });
    navL2.on('click keydown', (event) => {
        // console.log(event)
        const $thisEl = $(event.currentTarget);
        const $parentItem = $thisEl.parent();
        navL2.parent().not($parentItem).removeClass('expanded');
        $parentItem.toggleClass('expanded');
    });



    $('.nav-menu-panel').on('click', (event) => {
        const target = event.target;
        if ($(target).closest('.nav-menu-panel__nav').length > 0) {
            // console.log(event)
        } else {
            navL1.parent().removeClass('expanded');
        }
    });

    $(document).on('keydown', (event) => {
        // console.log(event)
        if ((event.key === 'Escape') && ($('body').hasClass('nav-menu-open'))) {
            if ($('.nav-menu-panel__nav .nav-items-1__item.expanded').length > 0) {
                $('.nav-menu-panel__nav .nav-items-1__item').removeClass('expanded');
            } else {
                // CLOSE MENU FUNCTION
                menuPanel.removeClass('menu-open');
                $('body').removeClass('nav-menu-open');
                menuBtn.focus();
            }
        }
    });











    menuBtn.on('click keydown', (event) => {
        if (event.type === 'click' || event.key === 'Enter') {
            menuPanel.toggleClass('menu-open');
            $('body').addClass('nav-menu-open');

            $('.nav-menu-panel__close').focus();
            trapFocus()
        }
    });

    closeBtn.on('click keydown', (event) => {
        if (event.type === 'click' || event.key === 'Enter') {
            menuPanel.removeClass('menu-open');
            $('body').removeClass('nav-menu-open');

            menuBtn.focus();
        }
    });



    function trapFocus() {
        const firstFocusable = $('.nav-menu-panel .nav-menu-panel__close');
        const lastFocusable = $('.nav-menu-panel #google_translate_element a');

        firstFocusable.on('keydown', (event) => {
            if (event.key === 'Tab') {
                if (event.shiftKey) {
                    event.preventDefault();
                    lastFocusable.focus();
                }
            }
        });

        lastFocusable.on('keydown', (event) => {
            if (event.key === 'Tab') {
                if (!event.shiftKey) {
                    event.preventDefault();
                    firstFocusable.focus();
                }
            }
        });
    }


}